import { FETCH_FAQS, SELECTED_FAQ, SHOW_BACK_SCREEN } from '../actions';

export const eventFAQs = (state = {}, action) => {
  if (action.type == FETCH_FAQS) {
    return action.payload;
  }
  return state;
};

export const selectedFAQ = (state = {}, action) => {
  if (action.type == SELECTED_FAQ) {
    return action.payload;
  }
  return state;
};

export const showBackFAQ = (state = false, action) => {
  if (action.type == SHOW_BACK_SCREEN) {
    return action.payload;
  }
  return state;
};
